var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSmartphone48Line = function SvgIconSmartphone48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 39.7H17.6a5.31 5.31 0 0 1-5.3-5.3V13.6c0-2.92 2.38-5.3 5.3-5.3h12.8c2.92 0 5.3 2.38 5.3 5.3v20.8c0 2.92-2.38 5.3-5.3 5.3Zm-12.8-28a1.9 1.9 0 0 0-1.9 1.9v20.8c0 1.05.85 1.9 1.9 1.9h12.8a1.9 1.9 0 0 0 1.9-1.9V13.6a1.9 1.9 0 0 0-1.9-1.9H17.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31.3h-6v3.4h6v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconSmartphone48Line;